import { gql } from "@apollo/client";

const UPDATE_ZONE = gql`
  mutation updateZone($id: ID!, $zone: ZoneUpdateinput!) {
    updateZone(id: $id, zone: $zone) {
      success
      message
      zone {
        id
      }
    }
  }
`;

const UPDATE_SUB_ZONE = gql`
  mutation updateSubZone($id: ID!, $subZone: SubZoneUpdateInput!) {
    updateSubZone(id: $id, subZone: $subZone) {
      success
      message
      subZone {
        id
      }
    }
  }
`;

const CREATE_SUB_ZONE = gql`
  mutation createSubZone($subZone: SubZoneCreateInput!) {
    createSubZone(subZone: $subZone) {
      success
      message
      subZone {
        id
      }
    }
  }
`;

export { UPDATE_ZONE, CREATE_SUB_ZONE, UPDATE_SUB_ZONE };
